import { Vue, Component } from 'vue-property-decorator';
import BCardCode from '@core/components/b-card-code/BCardCode.vue';
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  BButton,
  BModal,
  BForm,
  BCardText,
  BImg,
  BBadge,
  BLink
} from 'bootstrap-vue';
import { VueGoodTable } from 'vue-good-table';
import { ListVue, listVueMixin } from '@/utility/pagination/list-vue.mixin';
import Pagination from '@/@core/components/paginations/Pagination.vue';
import { OtherServiceListViewModel } from '@/api/api';
import {
  otherServiceListDispatcher,
  OtherServiceListInput,
  otherServiceListNamespace
} from './store/other-service-list.module';
import {
  ListGetter,
  ListGetterTypes
} from '@/utility/pagination/get-list.module-type';
import { DEFAULT_PAGE_SIZE } from '@/utility/pagination/pagination';
import OtherServiceFormModal from '@/components/otherServices/OtherServiceFormModal.vue';
import router from '@/router';
import OtherServiceFormModalClass from '@/components/otherServices/OtherServiceFormModal';
import { formatThousand } from '@/utility/utils';
import ApiClientFactory from '@/api/apiClientFactory';
@Component({
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCardCode,
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
    BModal,
    BForm,
    BCardText,
    Pagination,
    BImg,
    BBadge,
    BLink,
    OtherServiceFormModal
  },
  mixins: [
    listVueMixin({
      initialInput: {
        itemsPerPage: DEFAULT_PAGE_SIZE,
        searchText: ''
      },
      dispatcher: otherServiceListDispatcher,
      debouncedWatchers: [(listInput) => listInput.searchText]
    })
  ]
})
export default class OtherServiceList
  extends Vue
  implements ListVue<OtherServiceListViewModel, OtherServiceListInput> {
  @otherServiceListNamespace.Getter(ListGetter.state)
  readonly listState!: ListGetterTypes<
    OtherServiceListViewModel,
    OtherServiceListInput
  >[ListGetter.state];

  $refs!: {
    otherServiceFormModal: InstanceType<typeof OtherServiceFormModalClass>;
  };

  mounted() {
    otherServiceListDispatcher.load();
  }

  edit(otherServiceListViewModel: OtherServiceListViewModel) {
    this.$refs.otherServiceFormModal.openEditModal(otherServiceListViewModel);
  }

  setPrice(id: number) {
    this.$router.push(`set-other-service-price/${id}`);
  }

  remove(id: number) {
    const client = new ApiClientFactory().otherServiceClient();
    client.delete(id).then(() => {
      otherServiceListDispatcher.load();
      // show toast
      this.$bvToast.toast('Xóa dịch vụ khác thành công', {
        title: 'Dịch vụ khác',
        toaster: 'b-toaster-bottom-right',
        variant: 'success'
      });
    });
  }

  headers = [
    {
      label: this.$t('Name'),
      field: 'name'
    },
    {
      label: '',
      field: '_action',
      sortable: false,
      width: '1%'
    }
  ];
}
